import { useEffect, useState } from 'react'
import DatePicker from 'react-datepicker'

import ArrowNext from '../../assets/img/arrow-next.svg?react'
import ArrowPrev from '../../assets/img/arrow-prev.svg?react'
import Calendar2Icon from '../../assets/img/ico-calendar-2.svg?react'

import type { FullCalendarApi } from './Calendar'

import 'react-datepicker/dist/react-datepicker.css'
import { format } from 'date-fns'

type CalendarTitleBlockProps = {
    dateFormat?: string
    calendarApi: FullCalendarApi | undefined
    view: string
    setSelectedDate?: (val: Date | null) => void
    setView: (val: string) => void
    selectedDate: Date | null
    showDayWeek?: boolean
}

export const CalendarTitleBlock: React.FC<CalendarTitleBlockProps> = ({
    dateFormat,
    calendarApi,
    setView,
    setSelectedDate,
    selectedDate,
    view,
    showDayWeek = false,
}) => {
    const [customText, setCustomText] = useState('')
    const handlePrev = () => {
        if (!calendarApi) return
        calendarApi?.prev()
        setSelectedDate && setSelectedDate(calendarApi.getDate())
    }
    useEffect(() => {
        if (selectedDate && calendarApi) {
            setCustomText(
                view === 'resourceTimelineDay'
                    ? format(
                          new Date(calendarApi.currentData.viewTitle),
                          'MMM d, yyyy',
                      )
                    : calendarApi.currentData.viewTitle,
            )
        }
    }, [selectedDate, calendarApi])
    const handleNext = () => {
        if (!calendarApi) return
        calendarApi?.next()
        setSelectedDate && setSelectedDate(calendarApi.getDate())
    }

    const handleViewChange = (newView: string) => {
        if (!calendarApi) return
        setView(newView)
        calendarApi?.changeView(newView)
        setSelectedDate && setSelectedDate(calendarApi.getDate())
    }

    return (
        <div className="calendar-header">
            <div className="flex items-center gap-20">
                <div className="flex items-center">
                    <DatePicker
                        selected={selectedDate}
                        className="calendar-title"
                        customInput={
                            <div style={{ marginRight: 12 }}>
                                {' '}
                                {customText}{' '}
                            </div>
                        }
                        onChange={(date: Date | null) => {
                            if (calendarApi && date) {
                                calendarApi.gotoDate(date)
                            }
                            setSelectedDate && setSelectedDate(date)
                        }}
                        dateFormat={dateFormat ? dateFormat : 'MMM d, yyyy'}
                    />
                    <span className="ico absolute right-4">
                        <Calendar2Icon />
                    </span>
                </div>
                <div className="flex items-center gap-8">
                    <button
                        className="btn btn--navigation btn--square btn--xs rounded-full"
                        onClick={handlePrev}
                    >
                        <ArrowPrev />
                    </button>
                    <button
                        className="btn btn--navigation btn--square btn--xs rounded-full"
                        onClick={handleNext}
                    >
                        <ArrowNext />
                    </button>
                </div>
            </div>
            {(showDayWeek || calendarApi) && (
                <div className="c-h-item">
                    <label className="calendar-mode" id="mode-days">
                        {['resourceTimelineDay', 'resourceTimelineWeek'].map(
                            (item, index) => (
                                <label
                                    key={index}
                                    className="calendar-mode-item"
                                >
                                    <input
                                        type="radio"
                                        checked={view === item}
                                        hidden
                                        onChange={() => handleViewChange(item)}
                                    />
                                    <div className="calendar-mode-btn btn">
                                        {item.replace('resourceTimeline', '')}
                                    </div>
                                </label>
                            ),
                        )}
                    </label>
                </div>
            )}
        </div>
    )
}
